import ClienteCreditoModel from "@/models/clienteCreditoModel";

import nfetch from "../utils/events/nfetch";

import { IService } from "./base/iService";

class ClienteCreditoService extends IService<ClienteCreditoModel> {
    constructor() {
        super("ClienteCredito");
    }

    public async getSaldoDevedorByClienteId(clienteId: number): Promise<number> {
        return await nfetch(`/${this.controllerName}/GetSaldoDevedorByClienteId?clienteId=${clienteId}`, {
            credentials: "same-origin",
            method: "get",
        })
            .withLoading()
            .resolveWithJSON<number>();
    }
}

export default new ClienteCreditoService();
